import { HTMLAttributes } from 'react';
import { Link } from 'react-router-dom';

import { Button, Empty, Typography } from 'antd';
import cn from 'classnames';

import NoDataIcon from 'assets/images/empty.svg?react';

import styles from './EmptyState.module.scss';

const { Title, Text } = Typography;

export interface IEmptyStateProps extends HTMLAttributes<HTMLDivElement> {
	title: string;
	desc?: string;
	buttonText?: string;
	buttonTo?: string;
	buttonHref?: string;
	buttonOnClick?: () => void;
	buttonIcon?: React.ReactNode;
}

export const EmptyState = ({
	className,
	title,
	desc,
	buttonText,
	buttonTo,
	buttonHref,
	buttonOnClick,
	buttonIcon,
	...props
}: IEmptyStateProps) => {
	return (
		<Empty
			{...props}
			className={cn(className, styles.emptyState)}
			image={<NoDataIcon />}
			imageStyle={{ height: 120, marginBottom: 20 }}
			description={
				<>
					<Title level={5}>{title}</Title>
					{desc && <Text type="secondary">{desc}</Text>}
				</>
			}>
			{buttonText && buttonTo && (
				<Link to={buttonTo}>
					<Button type="primary" icon={buttonIcon}>
						{buttonText}
					</Button>
				</Link>
			)}

			{buttonText && buttonHref && (
				<Button type="primary" href={buttonHref} icon={buttonIcon}>
					{buttonText}
				</Button>
			)}

			{buttonText && buttonOnClick && (
				<Button type="primary" onClick={buttonOnClick} icon={buttonIcon}>
					{buttonText}
				</Button>
			)}
		</Empty>
	);
};

export default EmptyState;
